module.exports = __webpack_public_path__ + "img/p10_07.09c6e8a7.jpg";